"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OMMStreamEvent = exports.DEFAULT_OMM_STREAMING_CONNECTION_NAME = void 0;
const item_stream_1 = require("./item-stream");
exports.DEFAULT_OMM_STREAMING_CONNECTION_NAME = 'streaming/pricing/main';
const Status = 'Status';
const Update = 'Update';
const Refresh = 'Refresh';
exports.OMMStreamEvent = Object.assign(Object.assign({}, item_stream_1.ItemStreamEvent), { Refresh,
    Status,
    Update });
